import { Link, LinkProps } from "react-router-dom";

import { EventBadge, useInitialFocus } from "@skv/core";
import { resizeImg } from "@skv/util";

interface OpportunityDetailsHeaderProps {
  title?: string;
  organisationName?: string;
  organisationMemberName?: string;
  imgSrc?: string;
  to: LinkProps["to"];
  eventDate?: string;
  isNew?: boolean;
  focusHeading?: boolean;
}

export const OpportunityDetailsHeader = ({
  title,
  organisationName,
  organisationMemberName,
  imgSrc,
  to,
  eventDate,
  isNew = false,
  focusHeading = false,
}: OpportunityDetailsHeaderProps): JSX.Element => {
  const opportunityHeaderRef = useInitialFocus<HTMLHeadingElement>({
    shouldFocus: focusHeading,
  });

  return (
    <header className="row mb-3">
      <div className="col-7">
        {isNew && <p className="text-danger mb-2">New</p>}
        {title && (
          <h1
            ref={opportunityHeaderRef}
            className="display-2 font-weight-bold"
            tabIndex={-1}
          >
            {title}
          </h1>
        )}

        <p>
          {organisationMemberName && (
            <>
              <b>{organisationMemberName}</b> <i>supported by</i>{" "}
            </>
          )}
          <Link className="link" to={to}>
            {organisationName || "View organisation"}
          </Link>
        </p>
        {eventDate && <EventBadge date={eventDate} />}
      </div>
      <div className="col-4 offset-1 d-flex flex-column justify-content-md-start align-items-start gap-3">
        {imgSrc && (
          <picture>
            <source
              media="(min-width: 1200px)"
              srcSet={[
                `${resizeImg(imgSrc, "120x90")} 1x`,
                `${resizeImg(imgSrc, "240x180")} 2x`,
              ].join(", ")}
            />
            <source
              srcSet={[
                `${resizeImg(imgSrc, "90x90")} 1x`,
                `${resizeImg(imgSrc, "180x180")} 2x`,
                `${resizeImg(imgSrc, "270x270")} 3x`,
              ].join(", ")}
            />
            <img
              src={resizeImg(imgSrc, "120x90")}
              className="img-fluid"
              alt={organisationName ? `Logo for ${organisationName}` : ""}
            />
          </picture>
        )}
      </div>
    </header>
  );
};
